import { initializeApp, FirebaseApp } from "firebase/app";
import { getStorage, FirebaseStorage } from "firebase/storage";
import { getFirestore, Firestore } from "firebase/firestore";
import { getRemoteConfig, RemoteConfig } from "firebase/remote-config";
import { FIREBASE_CONFIG } from "./app";

export const app: FirebaseApp = initializeApp(FIREBASE_CONFIG);
export const db: Firestore = getFirestore(app);
export const storage: FirebaseStorage = getStorage(app);

// Initialize Remote Config
export const remoteConfig: RemoteConfig = getRemoteConfig(app);

// Configure Remote Config for development/testing
// remoteConfig.settings.minimumFetchIntervalMillis = 0; // Allow immediate fetches for testing
remoteConfig.settings.fetchTimeoutMillis = 10000; // 10 second timeout

// Set default values from master config
remoteConfig.defaultConfig = FIREBASE_CONFIG.remoteConfigDefaults;
